export class SearchMedicalReportHistorialRequest {
  FromDate?: Date;
  ToDate?: Date;
  Protocol?: string;
  PracticeRegionId?: number;
  ReportRegionId?: number;
  ReportingPhysicianId?: number;
  SpecialtyId?: number;
}
